import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";

// Define an async thunk to fetch data from the API

export const fetchProductList = createAsyncThunk(
    "subscription/fetchProductList",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get("/payment/product-list");
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const createNewSubscription = createAsyncThunk(
    "subscription/createNewSubscription",
    async ({ user_email, id, quantity }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post("payment/multi-community-subscription", {
                user_email,
                id,
                quantity,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const updateSubscriptionPrice = createAsyncThunk(
    "subscription/updateSubscriptionPrice",
    async ({ product_id, price }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(`/payment/update-subscription-price`, {
                product_id: product_id,
                price: price,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const fetchUserSubscriptions = createAsyncThunk(
    "subscription/fetchProductList",
    async ({ search, page, page_size }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/payment/user-subscriptions?search=${search}&page=${page}&page_size=${page_size}`);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const fetchRevenueSubscriptions = createAsyncThunk(
    "subscription/fetchProductList",
    async (search, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/payment/revenue-subscription`);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);


